import Vue from 'vue'
import { initialChantierState } from './state'
import resetState from '@/utils/resetState'

export default {
  updatePours(state, pours) {
    Vue.set(state, 'pours', pours)
  },

  updatePour(state, pour) {
    const index = state.pours.findIndex((_p) => _p.gid === pour.gid)
    if (index >= 0) {
      Vue.set(state.pours, index, pour)
    } else {
      state.pours.push(pour)
      Vue.set(state, 'pours', state.pours)
    }
  },

  clearState(state) {
    resetState(state, initialChantierState)
  },
}
